import { render, staticRenderFns } from "./specialSubject.vue?vue&type=template&id=3f04f7ff&scoped=true&"
import script from "./specialSubject.vue?vue&type=script&lang=js&"
export * from "./specialSubject.vue?vue&type=script&lang=js&"
import style0 from "./specialSubject.vue?vue&type=style&index=0&id=3f04f7ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04f7ff",
  null
  
)

export default component.exports